module.exports = __webpack_public_path__ + "static/media/barcodeIcon.d933581e.jpg";